module.exports = __webpack_public_path__ + "static/media/DoctorLanding.9da8efcf.jpg";